enum InvoiceAttachmentStatus {
    Unsent = 'UNSENT',
    Processing = 'PROCESSING',
    Sent = 'SENT',
}

export default InvoiceAttachmentStatus;
